import type { FormFlow, FmpFormStep } from '../../../types/form'
import type { FormStepResult } from '../../types'
import { FormTypeEnum } from '@strata-monorepo/shared-types'
import { energyPlanIncludes } from '../questions/energyPlanIncludes'
import { homeInfo } from '../questions/homeInfo'
import { addressStepFamily } from '../questions/addressAndMover'

export const FMP_FORM_NAME = 'fmp_v1'

export const createShortQuiz = (formResults: FormStepResult = {}): FormFlow => {
  const { question: currentAddressQuestion } = addressStepFamily(formResults).resolve()

  const addressAndMoverQuestion: FmpFormStep = {
    ...currentAddressQuestion,
    componentProps: {
      ...currentAddressQuestion.componentProps,
      shouldFetchConsumptionPrediction: true,
    },
  }

  const homeInfoQuestion = {
    ...homeInfo,
    componentProps: {
      ...homeInfo.componentProps,
      shouldFetchConsumptionPrediction: true,
    },
  }

  const energyPlanIncludesQuestion = {
    ...energyPlanIncludes,
    componentProps: {
      ...energyPlanIncludes.componentProps,
      tracking: {
        ...energyPlanIncludes.componentProps.tracking,
        deepStepNumber: 2,
        quickStepNumber: 2,
        deepStepId: '2',
        quickStepId: '2',
      },
    },
  }

  const shortQuizQuestions: FmpFormStep[] = [
    addressAndMoverQuestion,
    homeInfoQuestion,
    energyPlanIncludesQuestion,
  ]

  return {
    version: FMP_FORM_NAME,
    questions: shortQuizQuestions,
    formType: FormTypeEnum.SHORT_FORM,
    progressDisplay: { mode: 'step', showSteps: true },
  }
}
